import { FormInstance } from "antd/lib/form"
import i18n from "Shared/locales/i18n"

const PasswordFormRule = [
    { required: true, message: i18n.t("validation:required"), trigger: "blur" },
    { min: 6, message: i18n.t("validation:min.string", { min: 6 }), trigger: "blur" },
]

export default PasswordFormRule

export const generateRules = (formInstance: FormInstance) => ({
    password: [
        { required: true, message: i18n.t("validation:required"), trigger: "blur" },
        { min: 6, message: i18n.t("validation:min.string", { min: 6 }), trigger: "blur" },
    ],
    confirmPassword: [
        { required: true, message: i18n.t("validation:required"), trigger: "blur" },
        { min: 6, message: i18n.t("validation:min.string", { min: 6 }), trigger: "blur" },
        {
            validator: (_rule: any, value: string) => {
                if (value !== formInstance.getFieldValue("password")) {
                    return Promise.reject(new Error(i18n.t("validation:password.notmatching")))
                }

                return Promise.resolve()
            },
        },
    ],
})
